import React from 'react';

const Pagination = ({ pagination, jumpToFirstPage, currentPagePagination, CardsPerPage, jumpToLastPage, filteredStudies, pmsChangeData }) => {
  return (
    <div className="pagination-container d-flex gap-2 align-items-center">
       {pmsChangeData && <b>
            Total Records Fetched : <span>{pmsChangeData.length}</span>
       </b>}
      <button className='white_btn py-1' onClick={jumpToFirstPage} disabled={currentPagePagination === 1}>
        {"<<"}
      </button>
      <button className='orange_btn  py-1' onClick={() => pagination(currentPagePagination - 1)} disabled={currentPagePagination === 1}>
        {"Prev"}
      </button>
      <span>{currentPagePagination}</span>of<span>{Math.ceil(filteredStudies.length / CardsPerPage)}</span>
      <button className='orange_btn  py-1' onClick={() => pagination(currentPagePagination + 1)} disabled={currentPagePagination === Math.ceil(filteredStudies.length / CardsPerPage)}>
        {"Next"}
      </button>
      <button className='white_btn py-1' onClick={jumpToLastPage} disabled={currentPagePagination === Math.ceil(filteredStudies.length / CardsPerPage)}>
        {">>"}
      </button>
    </div>
  )
}


export default Pagination;

